
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      rules: {},
      isLoading: false,

      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      }
    };
  },
  methods: {
    submitForm() {
      this.isLoading = true;
      var _this = this;
      api
        .postForm("/common/sysfeedback/mgxyContact.ht", {
          tokenId: _this.userInfo.token,
          lastName: _this.step2Form.lastName,
          firstName: _this.step2Form.firstName,
          email: _this.step2Form.email,
          phone: _this.step2Form.phone,
          content: _this.step2Form.content
        })
        .then(res => {
          this.isLoading = false;
          this.$router.push({
            path: `/`,
            query: {}
          });
        });
    }
  }, //end of methods
  mounted() {
  },
  head() {
    return {
      title: 'Contact American Credit | Call, Chat or Form Fill',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Have questions about American Credit\'s small business loans? Give us a call, chat online or use our secure form. Our loan specialists are here to help you!'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'american credit background, small business financing, american credit history, american credit'
        }
      ]
    }
  }
};
